import type { GapActionFlagPillData } from "./gapActionDrawerConstants";
import type { GapAnalysisDimension } from "./gapAnalysisConstants";

const RUBRIC_QUALITY_DIMENSION_ID = "rubric-quality";

export function getOverriddenPillLabel(
  pill: GapActionFlagPillData,
  dimensions?: GapAnalysisDimension[]
): GapActionFlagPillData {
  if (pill.dimensionId === RUBRIC_QUALITY_DIMENSION_ID && dimensions) {
    const rubricQualityDimension = dimensions.find((d) => d.id === RUBRIC_QUALITY_DIMENSION_ID);
    if (rubricQualityDimension) {
      return {
        ...pill,
        label: rubricQualityDimension.label,
      };
    }
  }
  return pill;
}

export function getOverriddenPillLabels(
  pills: GapActionFlagPillData[],
  dimensions?: GapAnalysisDimension[]
): GapActionFlagPillData[] {
  return pills.map((pill) => getOverriddenPillLabel(pill, dimensions));
}

export function getOverriddenDimensionLabel(
  dimension: GapAnalysisDimension,
  frameworkName?: string | null
): GapAnalysisDimension {
  if (dimension.id === RUBRIC_QUALITY_DIMENSION_ID && frameworkName) {
    return {
      ...dimension,
      label: frameworkName,
    };
  }
  return dimension;
}
